
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 6.749H2a1.25 1.25 0 000 2.5h28a1.25 1.25 0 000-2.5zm-6 8.001H8a1.25 1.25 0 000 2.5h16a1.25 1.25 0 000-2.5zm-5 8h-6.053a1.25 1.25 0 000 2.5H19a1.25 1.25 0 000-2.5z"}})])
          )
        }
      }
    